var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRPhoneOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-phone-out-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.746,11.141c-0.003,0.003 -1.207,1.209 -1.207,1.209c-0.905,0.904 -1.3,2.258 -0.857,3.516c-0,0 -0,0 -0,0c1.093,3.106 2.871,5.925 5.202,8.249c2.324,2.332 5.144,4.11 8.25,5.202c1.26,0.444 2.612,0.049 3.517,-0.855c-0,-0 1.208,-1.209 1.208,-1.209c0.931,-0.929 0.835,-2.465 -0.204,-3.273l-2.696,-2.097c-0.53,-0.412 -1.221,-0.558 -1.873,-0.395l-2.559,0.639c-0.219,0.055 -0.452,-0.009 -0.612,-0.169c-0,-0 -2.872,-2.872 -2.872,-2.872c-0.16,-0.16 -0.224,-0.393 -0.17,-0.612c0,0 0.64,-2.56 0.64,-2.56c0.163,-0.652 0.017,-1.343 -0.395,-1.873l-2.097,-2.696c-0.415,-0.533 -1.053,-0.845 -1.728,-0.845c-0.58,0 -1.137,0.231 -1.547,0.641Zm2.057,1.15l2.097,2.697c0.121,0.156 0.164,0.36 0.116,0.552l-0.64,2.56c-0.186,0.745 0.033,1.535 0.576,2.077l2.871,2.872c0.543,0.543 1.333,0.762 2.078,0.576l2.56,-0.64c0.192,-0.048 0.395,-0.005 0.551,0.116l2.697,2.097c0.157,0.122 0.249,0.311 0.249,0.51c0,0.171 -0.068,0.335 -0.189,0.456l-1.209,1.209c-0.524,0.523 -1.265,0.719 -1.915,0.491c-2.887,-1.017 -5.509,-2.67 -7.67,-4.838c0,0 0,0 0,0c-2.168,-2.161 -3.821,-4.782 -4.837,-7.669c-0.229,-0.651 -0.032,-1.392 0.491,-1.916l1.209,-1.21c0.121,-0.121 0.285,-0.189 0.456,-0.189c0.199,-0 0.387,0.092 0.509,0.249Zm8.557,-1.058c-0,0.401 0.33,0.732 0.732,0.732l2.908,-0l-4.595,4.594c-0.138,0.138 -0.215,0.324 -0.215,0.519c-0,0.402 0.331,0.732 0.733,0.732c0.194,0 0.381,-0.077 0.518,-0.214l4.595,-4.596l-0,2.909c-0,0.401 0.33,0.732 0.732,0.732c0.402,-0 0.732,-0.331 0.732,-0.732c0,-0 0,-4.676 0,-4.676c0,-0.402 -0.33,-0.733 -0.732,-0.733c-0,0 -4.676,0 -4.676,0c-0.402,0 -0.732,0.331 -0.732,0.733Z",
    style: {
      fill: "#293583",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRPhoneOut);
export default __webpack_public_path__ + "static/media/iconR-phone-out.1f216383f7f4a87fa4e01f107c85ba01.svg";
export { ForwardRef as ReactComponent };